import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getErrataList } from '@/api/modules/study';
import { mapGetters } from 'vuex';
export default {
  props: {
    selectNode: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    boxId: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      isShowErrata: false,
      visible: false,
      erratas: []
    };
  },
  computed: _objectSpread({}, mapGetters({
    userMode: 'userMode'
  })),
  watch: {
    boxId: {
      immediate: true,
      handler: function handler(val) {
        val && this.getErrata();
      }
    }
  },
  methods: {
    guideClick: function guideClick() {
      // 点击"使用引导"
      this.$emit('nodeClick', null);
    },
    toggleVisible: function toggleVisible() {
      this.visible = !this.visible;
    },
    getErrata: function getErrata() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$getErrataList, status, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.userMode !== 'normal')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return getErrataList({
                  boxId: _this.boxId
                });

              case 4:
                _yield$getErrataList = _context.sent;
                status = _yield$getErrataList.status;
                data = _yield$getErrataList.data;

                if (status === 1) {
                  _this.erratas = Array.isArray(data.erratas) ? data.erratas : [];
                  _this.isShowErrata = _this.erratas.length > 0;
                } else {
                  _this.erratas = [];
                  _this.isShowErrata = false;
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};